Customer.Dashboard ||= {}

class Customer.Dashboard.History extends Backbone.Router
  routes:
    "filter/:filter": "_standardRoute"
    "filter/:filter/conversation/:conversation": "_standardRoute"
    "conversation/:conversation": "_noFilterRoute"

  initialize: ->
    @clearState()

  clearState: ->
    @filter = null
    @conversation = null
    @

  setFilter: (id) ->
    @filter = parseInt id
    @

  setConversation: (id) ->
    @conversation = parseInt id
    @

  go: ->
    configurations = []
    if @filter
      configurations.push "filter/#{@filter}"
    if @conversation
      configurations.push "conversation/#{@conversation}"
    url = configurations.join("/")
    @navigate url

  _noFilterRoute: (conversation) ->
    @_standardRoute null, conversation

  _standardRoute: (filter, conversation)  ->
    @filter = parseInt filter
    @conversation = parseInt conversation
    @trigger('url:anchor:changed')
